import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setView } from '../redux/actions/select'

import { Grid, Paper, Typography, TablePagination, FormControlLabel, Radio, withStyles } from '@material-ui/core'

import { DateRangePicker, SingleDatePicker } from 'react-dates'

// import {
//   Assignment as TopWebsitesIcon, AssignmentInd as TopUsersIcon, AssignmentLate as TopPhrasesIcon
// } from '@material-ui/icons'

import { makeStyles } from '@material-ui/core/styles'

import { UsersReport, PhrasesReport, WebsitesReport, SupervisorActivityReport, SupervisorLoginReport } from '../components/ui'

// import { defaultFilter } from '../utils'

import moment from 'moment'
// import { ElevioIntegration } from '../components/ui/tools'

const useStyles = makeStyles((theme) => ({
  backBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  deleteBtn: {
    backgroundColor: theme.palette.action.active,
    margin: 'auto',
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.error.light
    }
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    borderRadius: '50%'
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  blueBackground: {
    backgroundColor: '#007BFF',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenBackground: {
    backgroundColor: '#97b557',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greyColor: {
    color: '#0000008A'
  },
  editPaper: {
    backgroundColor: '#ffffff',
    maxHeight: '50em',
    overflow: 'scroll'
  },
  wordList: {
    width: '100%'
  },
  customText: {
    textTransform: 'none !important',
    marginTop: '1rem'
  },
  tableContainer: {
    height: 'auto'
  },
  tablePaper: {
    height: '60vh',
    overflow: 'scroll'
  },
  tableText: {
    fontWeight: 'bold',
    color: '#A4D164'
  },
  tableHeadText: {
    fontWeight: 'bold',
    color: '#007bff'
  },
  table: {
    height: 250
  },
  greenText: {
    color: '#97b557'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  headerPaper: {
    marginBottom: '1rem',
    alignItems: 'center',
    display: 'flex',
    padding: '.5rem',
    minWidth: '650px'
  },
  navBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    borderRadius: '50%',
    width: '50px',
    height: '50px'
  },
  icon: {
    fontSize: '2.4rem'
  },
  reportButtonText: {
    fontSize: '.9rem',
    fontWeight: 'bold',
    color: 'grey'
  },
  tableHeadSortText: {
    fontSize: '1rem',
    color: '#0065d2 !important'
  },
  dateSelect: {
    '.DateRangePickerInput__withBorder': '1px solid green'
  },
  paginationSelect: {
    marginRight: '15px'
  },
  paginationActions: {
    marginLeft: '10px'
  }
}))

const StyledRadio = withStyles({
  root: {
    color: '#A4D164',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Radio color='default' {...props} />)

/**
 * Creates a page that displays reports
 */
const ReportsView = (props) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { fromLink } = props

  const SelectedReport = useSelector(state => state.selection.Report)

  const usersReport = useSelector(state => state.reports.usersReport)
  const phrasesReport = useSelector(state => state.reports.phrasesReport)
  const websitesReport = useSelector(state => state.reports.websitesReport)
  const supervisorActivityReport = useSelector(state => state.reports.supervisorActivityReport)
  const supervisorLoginReport = useSelector(state => state.reports.supervisorLoginReport)
  // const Filter = useSelector(state => state.selection.Filter)

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  /* STATE FOR SUPERVISOR ACTIVITY REPORT DATE PICKER */
  const [focusedInput, setFocusedInput] = useState(null)
  const [singleFocusedInput, setSingleFocusedInput] = useState(null)
  const [startDate, setStartDate] = useState(moment().subtract(7, 'days'))
  const [endDate, setEndDate] = useState(moment())
  // Filter passed in with start and end dates for supervisor report
  const [supervisorFilter, setSupervisorFilter] = useState({ startDate: moment().startOf('day').subtract(7, 'days').unix(), endDate: moment().endOf('day').unix() })

  // Max number of selectable days for date range picker
  const maximumDays = 90

  const [dateSelectType, setDateSelectType] = useState('range')

  useEffect(() => {
    dispatch(setView('reports'))
  }, [dispatch])

  const getSelectedForm = () => {
    return (
      <>
        {(() => {
          switch (SelectedReport) {
            case 'users':
              return <UsersReport classes={classes} page={page} rowsPerPage={rowsPerPage} usersReport={usersReport} fromLink={fromLink} />
            case 'phrases':
              return <PhrasesReport classes={classes} page={page} rowsPerPage={rowsPerPage} phrasesReport={phrasesReport} fromLink={fromLink} />
            case 'websites':
              return <WebsitesReport classes={classes} page={page} rowsPerPage={rowsPerPage} websitesReport={websitesReport} fromLink={fromLink} />
            case 'supervisor-report':
              return (
                <SupervisorActivityReport
                  classes={classes}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  supervisorActivityReport={supervisorActivityReport}
                  fromLink={fromLink}
                  supervisorFilter={supervisorFilter}
                  setSupervisorFilter={setSupervisorFilter}
                  startDate={startDate}
                  endDate={endDate}
                />
              )
            case 'supervisor-login-report':
              return (
                <SupervisorLoginReport
                  classes={classes}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  supervisorLoginReport={supervisorLoginReport}
                  fromLink={fromLink}
                  supervisorFilter={supervisorFilter}
                  setSupervisorFilter={setSupervisorFilter}
                  startDate={startDate}
                  endDate={endDate}
                />
              )
            default:
              return null
          }
        })()}
      </>
    )
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    setPage(0)
  }

  /* FUNCTIONS FOR SUPERVISOR ACTIVITY REPORT DATE PICKER */
  // Allows DateRangePicker to Select Values outside its range
  // const outsideRange = () => false

  const handleFocusedInput = (focus) => {
    setFocusedInput(focus)
  }

  const handleSingleFocus = (focus) => {
    setSingleFocusedInput(focus.focused)
  }

  // Allows DateRangePicker to Select Values outside its range
  const outsideRange = () => false

  const handleDateType = (type) => {
    // Reset dates if changing date type
    if (type !== dateSelectType) {
      setStartDate(null)
      setEndDate(null)
      setSupervisorFilter({ ...supervisorFilter, startDate: 0, endDate: 0 })
    }

    setDateSelectType(type)
  }

  // const handleDateType = (type) => {
  //   if (newFormData.startDate !== '' || newFormData.endDate !== '') {
  //     setFormData({ ...newFormData, startDate: '', endDate: '' })
  //   }
  //   setDateSelectType(type)
  // }

  // Set start and end date for supervisor activity report
  const handleDateChange = async (startDate, endDate) => {
    // Set display dates
    setStartDate(startDate)
    setEndDate(endDate)

    // Reset start and end dates on supervisor filter if date picker values are cleared and set to nul
    if (startDate === null && endDate === null) { setSupervisorFilter({ ...supervisorFilter, startDate: 0, endDate: 0 }) }

    if (startDate && startDate >= 0) { startDate = moment(startDate._d).format('YYYY-MM-DD') } else { startDate = 0 }
    if (endDate && endDate >= 0) { endDate = moment(endDate._d).format('YYYY-MM-DD') } else { endDate = 0 }

    // Format timestamps
    const formatDates = (start, end) => {
      const rangeStart = moment(start + ' ' + moment().startOf('day').format('hh:mm:ss a'), 'YYYY-MM-DD hh:mm:ss a')
      startDate = moment(rangeStart._i, 'YYYY-MM-DD hh:mm:ss a').unix()

      // If the date type is range, endDate is used. If type is single, the same startDate is used set to end of day.
      if (dateSelectType === 'range' && end !== 0) {
        const rangeEnd = moment(end + ' ' + moment().endOf('day').format('hh:mm:ss a'), 'YYYY-MM-DD hh:mm:ss a')
        endDate = moment(rangeEnd._i, 'YYYY-MM-DD hh:mm:ss a').unix()
      } else { endDate = 0 }

      if (dateSelectType === 'single') {
        const rangeEnd = moment(start + ' ' + moment().endOf('day').format('hh:mm:ss a'), 'YYYY-MM-DD hh:mm:ss a')
        endDate = moment(rangeEnd._i, 'YYYY-MM-DD hh:mm:ss a').unix()
      }
    }

    // Use function to format timestamps and set supervisor filter if startDate exists
    if ((dateSelectType === 'range' && (startDate !== 0 && startDate !== null) && (endDate !== 0 && endDate !== null))) {
      formatDates(startDate, endDate)
      setSupervisorFilter({ ...supervisorFilter, startDate, endDate })
    } else if ((dateSelectType === 'single') && (startDate !== 0 && startDate !== null)) {
      formatDates(startDate, endDate)
      setSupervisorFilter({ ...supervisorFilter, startDate, endDate })
    }
  }

  // Check startDate or endDate if selected first to set selectable range
  const handleRange = (day) => {
    if (focusedInput === 'startDate' && startDate !== null && endDate === null && (
      day.isBefore(startDate) ||
      day.isAfter(startDate.clone().add(maximumDays, 'days')))
    ) {
      return true
    } else if (focusedInput === 'startDate' && startDate === null && endDate !== null && (
      day.isAfter(endDate) ||
      day.isBefore(endDate.clone().subtract(maximumDays, 'days')))
    ) {
      return true
    } else if (focusedInput === 'startDate' && startDate !== null && endDate !== null && (
      day.isBefore(startDate.clone().subtract(maximumDays - endDate.diff(startDate, 'days'), 'days')) ||
      day.isAfter(endDate.clone().add(maximumDays, 'days')))
    ) {
      return true
    } else if (focusedInput === 'endDate' && startDate !== null && endDate === null && (
      day.isBefore(startDate) ||
      day.isAfter(startDate.clone().add(maximumDays, 'days')))
    ) {
      return true
    } else if (focusedInput === 'endDate' && startDate === null && endDate !== null && (
      day.isAfter(endDate) ||
      day.isBefore(endDate.clone().subtract(maximumDays, 'days')))
    ) {
      return true
    } else if (focusedInput === 'endDate' && startDate !== null && endDate !== null && (
      day.isBefore(startDate.clone().subtract(maximumDays - endDate.diff(startDate, 'days'), 'days')) ||
      day.isAfter(endDate.clone().add(maximumDays - endDate.diff(startDate, 'days'), 'days')))
    ) {
      return true
    } else {
      return false
    }
  }

  // Check and return total count for reports
  const handleReportTotal = (report) => {
    const userReportTotal = usersReport && usersReport.length ? usersReport.length : 0
    const phraseReportTotal = phrasesReport && phrasesReport.length ? phrasesReport.length : 0
    const websiteReportTotal = websitesReport && websitesReport.length ? websitesReport.length : 0
    const supervisorActivityReportTotal = supervisorActivityReport && supervisorActivityReport.length ? supervisorActivityReport.length : 0
    const supervisorLoginReportTotal = supervisorLoginReport && supervisorLoginReport.length ? supervisorLoginReport.length : 0

    switch (report) {
      case 'users':
        return userReportTotal
      case 'phrases':
        return phraseReportTotal
      case 'websites':
        return websiteReportTotal
      case 'supervisor-report':
        return supervisorActivityReportTotal
      case 'supervisor-login-report':
        return supervisorLoginReportTotal
      default:
        return 0
    }
  }

  // Displayed numbers for pagination --- Display total + if they are over the limit
  const handleDisplayedRows = (from, to, count) => {
    switch (SelectedReport) {
      case 'users':
        return `${from}-${to} of ${count < 3000 ? count : '3000 +'}`
      case 'phrases':
        return `${from}-${to} of ${count < 1000 ? count : '1000 +'}`
      case 'websites':
        return `${from}-${to} of ${count < 1000 ? count : '1000 +'}`
      case 'supervisor-report':
        return `${from}-${to} of ${count}`
      case 'supervisor-login-report':
        return `${from}-${to} of ${count}`
      default:
        return '0 - 0 of 0'
    }
  }

  const HeaderContent = () => {
    return (
      <>
        <Paper elevation={2} className={classes.headerPaper}>
          <Grid item container direction='row' justify='center' alignItems='center' style={{ marginTop: '.5rem' }}>
            <Grid item container direction='column' xs={12}>
              <Grid item container direction='row' justify='space-between' alignItems='center' style={{ marginLeft: '.5rem' }}>
                <Typography
                  style={{ marginLeft: '.5rem', fontWeight: 'bold', color: '#0000008A', fontSize: '2.2rem' }}
                >
                  {
                    SelectedReport === 'supervisor-report'
                      ? 'Supervisor Activity Report'
                      : SelectedReport === 'supervisor-login-report'
                        ? 'Supervisor Login Report'
                        : `Captures By ${SelectedReport === 'users' ? 'User' : SelectedReport === 'phrases' ? 'Phrase' : 'Website'} Report`
                  }
                </Typography>
              </Grid>
            </Grid>

            {(SelectedReport === 'supervisor-report' || SelectedReport === 'supervisor-login-report') &&
              <Grid item container direction='row' justify='flex-start' style={{ marginTop: '1rem', marginLeft: '.5rem' }}>
                <FormControlLabel
                  value='single'
                  control={
                    <StyledRadio
                      size='small'
                      checked={dateSelectType === 'single'}
                      onClick={(e) => handleDateType(e.target.value)}
                    />
                  }
                  label='Single'
                  labelPlacement='end'
                  style={{ margin: 0 }}
                />
                <FormControlLabel
                  value='range'
                  control={
                    <StyledRadio
                      size='small'
                      checked={dateSelectType === 'range'}
                      onClick={(e) => handleDateType(e.target.value)}
                    />
                  }
                  label='Range'
                  labelPlacement='end'
                  style={{ margin: 0 }}
                />
              </Grid>}

            <Grid item container direction='row' justify='center'>

              <Grid item xs={4}>
                {(SelectedReport === 'supervisor-report' || SelectedReport === 'supervisor-login-report') && dateSelectType === 'range' &&
                  <Grid item style={{ marginLeft: '1rem', marginTop: '.5rem' }}>
                    <DateRangePicker
                      small
                      showClearDates
                      startDate={startDate}
                      startDateId='unique_start_date_id'
                      endDate={endDate}
                      endDateId='unique_end_date_id'
                      onDatesChange={({ startDate, endDate }) => handleDateChange(startDate, endDate)}
                      focusedInput={focusedInput}
                      onFocusChange={focusedInput => handleFocusedInput(focusedInput)}
                      startDatePlaceholderText='Start Date'
                      endDatePlaceholderText='End Date'
                      isOutsideRange={(day) => handleRange(day)}
                      isDayBlocked={(day) => day.isAfter(moment())}
                      orientation='vertical'
                      openDirection='down'
                    />
                  </Grid>}

                {(SelectedReport === 'supervisor-report' || SelectedReport === 'supervisor-login-report') && dateSelectType === 'single' &&
                  <Grid item style={{ marginLeft: '1rem', marginTop: '.5rem' }}>
                    <SingleDatePicker
                      small
                      showClearDate
                      date={startDate}
                      onDateChange={date => handleDateChange(date, null)}
                      focused={singleFocusedInput}
                      onFocusChange={(focused) => handleSingleFocus(focused)}
                      isDayBlocked={(day) => day.isAfter(moment())}
                      id='SingleDatePicker'
                      isOutsideRange={outsideRange}
                      orientation='vertical'
                      openDirection='down'
                    />
                  </Grid>}
              </Grid>

              <Grid item xs={4}>
                <Grid item container direction='row' justify='center'>
                  <TablePagination
                    component='div'
                    labelRowsPerPage=''
                    labelDisplayedRows={({ from, to, count }) => handleDisplayedRows(from, to, count)}
                    count={handleReportTotal(SelectedReport)}
                    page={page}
                    onChangePage={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    rowsPerPageOptions={[100, 50, 25]}
                    color='secondary'
                    classes={{
                      selectRoot: classes.paginationSelect,
                      actions: classes.paginationActions
                    }}
                  />
                </Grid>
              </Grid>

              <Grid item xs={4} />

            </Grid>

          </Grid>
        </Paper>
      </>
    )
  }

  return (
    <div
      className='grid row justify-content-center no-gutters'
      style={{ paddingTop: '50px', paddingBottom: '50px', paddingLeft: '140px', paddingRight: '140px' }}
    >
      <Grid
        item
        container
        direction='row'
        justify='center'
        style={{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }}
      >
        <Grid item container direction='column' xs={11}>
          <HeaderContent />
          {getSelectedForm()}
        </Grid>
        {/* <ElevioIntegration keywords={['Reports']} /> */}
      </Grid>
    </div>
  )
}

export default ReportsView
